import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import { ShipperIcon } from '@img/icons';
import { GavelIcon, LocationOnIcon } from '@img/icons';
import { navigator, USER_PERMISSION } from '@types';

const configNav = (userRoles: string[] = [], customerFuelLevyActive = false) => {
	const root = `/configuration`;
	/* One nav entry either way: the flag decides whether it leads to the Ofload-only page or to
	   the Customer levy pages that replace it. Both the link and the highlight read off this, so
	   the two cannot drift apart. */
	const fuelLevyPath = customerFuelLevyActive ? 'fuel-levies' : 'fuel-levy';

	return ([
		{
			label: 'Dashboard',
			icon: (color:string) => <DashboardIcon style={{ color: color }} />,
			link: `${root}/dashboard`,
			enabled: true,
			activeURL: 'dashboard'
		},
		{
			label: 'Rate Cards',
			icon: (color:string) => <PriceChangeOutlinedIcon style={{ color: color }} />,
			link: `${root}/ratecards`,
			activeURL: 'ratecards',
			enabled: true,
		},
		{
			label: 'Regions',
			icon: (color:string) => <MapOutlinedIcon style={{ color: color }} />,
			link: `${root}/regions`,
			activeURL: 'regions',
			enabled: true
		},
		{
			label: 'Locations',
			icon: (color: string) => <LocationOnIcon color={color}/>,
			link: `${root}/locations`,
			enabled: true,
			activeURL: 'locations'
		},
		{
			label: 'Auto Allocation',
			icon: (color: string) => <SettingsSuggestIcon style={{ color: color }}/>,
			link: `${root}/auto-allocation`,
			enabled: true,
			activeURL: 'auto-allocation'
		},
		{
			label: 'Registered Shippers',
			icon: (color:string) => <ShipperIcon width={22} height={22} color={color} />,
			link: `${root}/registered-shippers`,
			enabled: true,
			activeURL: 'registered-shippers'
		},
		{
			label: 'Registered Carriers',
			icon: (color:string) => <LocalShippingOutlinedIcon style={{ color: color }} />,
			link: `${root}/registered-carriers`,
			enabled: true,
			activeURL: 'registered-carriers'
		},
		{
			label: 'Fuel Levy',
			icon: (color:string) => <LocalGasStationOutlinedIcon style={{ color: color }} />,
			link: `${root}/${fuelLevyPath}/shipper`,
			enabled: true,
			activeURL: fuelLevyPath
		},
		{
			label: 'Marketplace',
			icon: (color:string) => <GavelIcon color={color} />,
			link: `${root}/marketplace`,
			activeURL: 'marketplace',
			enabled: true
		},
		{
			label: 'Company',
			icon: (color:string) => <StoreOutlinedIcon style={{ color: color }} />,
			link: `${root}/company`,
			enabled: true,
			activeURL: 'company',
		},
		{
			label: 'Tags',
			icon: (color:string) => <LocalOfferOutlinedIcon style={{ color: color, transform: 'scaleX(-1)' }} />,
			link: `${root}/tags`,
			enabled: true,
			activeURL: 'tags',
		},
		{
			label: 'Data Bulk Upload',
			icon: (color:string) => <FileUploadOutlinedIcon style={{ color: color, transform: 'scaleX(-1)' }} />,
			link: `${root}/data-bulk-upload`,
			enabled: true,
			activeURL: 'data-bulk-upload',
		},
		{
			label: 'Feature Flags',
			icon: (color:string) => <ToggleOnOutlinedIcon style={{ color: color }} />,
			link: `${root}/feature-flags`,
			enabled: true,
			activeURL: 'feature-flags',
		}
	] as navigator[])
		.filter((item) => {
			switch (item.activeURL) {
			case 'data-bulk-upload':
				return userRoles.includes('bulk issues claims uploader');
			case 'feature-flags':
				return userRoles.includes(USER_PERMISSION.FEATURE_FLAG_MANAGER);
			default:
				return true;
			}
		}
		);
}

export default configNav;
